import { FAQItem } from '../types';

export const faqItems: FAQItem[] = [
  {
    question: 'XamXamBoutik est-il difficile à utiliser ?',
    answer:
      "Si vous savez utiliser WhatsApp, vous savez utiliser XamXamBoutik. L'interface est conçue pour les commerçants, pas pour les informaticiens. La plupart maîtrisent l'essentiel en moins de 30 minutes, avec un guide interactif qui vous accompagne pas à pas.",
  },
  {
    question: 'Puis-je essayer avant de payer ?',
    answer:
      "Oui, vous bénéficiez d'1 mois d'essai gratuit avec accès à toutes les fonctionnalités. Vous ne payez rien pendant 1 mois. Le paiement se fait par Orange Money ou Wave.",
  },
  {
    question: 'Comment importer mes produits existants ?',
    answer:
      "Vous pouvez importer 500 produits en 5 minutes via un fichier Excel. Préparez simplement un tableau avec les noms, prix et quantités, et XamXamBoutik fait le reste. Vous pouvez aussi ajouter les produits manuellement un par un.",
  },
  {
    question: 'Mes employés ne sont pas à l\'aise avec la technologie. Comment faire ?',
    answer:
      "C'est le cas de 90% de nos utilisateurs au début. L'interface est faite pour eux : grosses icônes, parcours simple, zéro jargon. La plupart des employés sont autonomes en 30 minutes. Et si besoin, notre équipe peut former votre équipe à distance.",
  },
  {
    question: 'Sur quels appareils ça fonctionne ?',
    answer:
      "XamXamBoutik fonctionne sur tous les appareils : smartphones, tablettes et ordinateurs. L'interface s'adapte automatiquement à la taille de votre écran pour une expérience optimale.",
  },
  {
    question: 'Comment contacter le support ?',
    answer:
      "Notre équipe support est disponible par WhatsApp (+221 78 875 20 20), email (support@xamxamboutik.com) et téléphone. Temps de réponse moyen : moins de 2 heures. Les utilisateurs Premium bénéficient d'un support prioritaire.",
  },
  {
    question: 'Combien de produits puis-je gérer ?',
    answer:
      "Il n'y a pas de limite sur le nombre de produits. Que vous ayez 50 ou 5 000 références, XamXamBoutik les gère avec la même rapidité grâce à la recherche intelligente et au scanner caméra.",
  },
];
